const videosGrid = document.querySelectorAll('.hover-videos');

videosGrid.forEach((grid) => {
    const videoPlayer = grid.querySelector('video')

    grid.addEventListener('mouseover', () => {
        videoPlayer.play();
    })

    grid.addEventListener('mouseleave', () => {
        videoPlayer.pause();
    })
})
